import axios from 'axios';


export const fetchgolfCourse = async () => {
    try {
        const response = await axios.post(`/api/GolfCourse/Search`, { CourseName: "" });
        if (response && response.status === 200) {
            return response.data.records;
        }
        else {
            console.error("Fetching Course Error")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
export const saveTournamentedEntry = async (values, userKey) => {
    var result = { Status: true, Message: "", Data: null };
    let hiddenHolesM = values.memberHiddenHoles.join(",");
    let hiddenHolesG = values.guestHiddenHoles.join(",");
    let sponsorIds;
    if (values.selectedSponsors.length > 0) {
        sponsorIds = values.selectedSponsors.map((i) => {
            return i.id
        })
    }
    var Maindata = {
        key: userKey,
        data: {
            TournamentDate: values.tournamentedDate,
            Title: values.title,
            GolfCourseKey: values.golfCourse.value,
            MemberScoreMethod: values.scoreMethodM.value,
            GuestScoreMethod: values.scoreMethodG.value,
            MemberHiddenHoles: hiddenHolesM,
            GuestHiddenHoles: hiddenHolesG,
            SponsorIds: values.selectedSponsors.length === 0 ? "" : sponsorIds.join(','),
            Status: values.status,
            GroupMemberScoreByHandicap: values.memberGroupByHandicap,
            GroupGuestScore: values.guestGroupScore,
            handicapValue: parseInt(values.handicapValue, 0),
            GroupCount: parseInt(values.playerGroups, 0),
            Timestamp: values.timestamp,
            CreatedBy: values.createdBy,
        }
    }
    if (values.tournamentedKey === '' || values.tournamentedKey === null) {
        try {
            const response = await axios.post(`/api/Tournamented/Create`, Maindata);
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    }
    else {
        try {
            const response = await axios.put(`/api/Tournamented/${values.tournamentedKey}`, Maindata.data)
            if (response && await response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    }
}
export const deleteTournamentedEntry = async (values) => {
    try {
        var result = { Status: true, Message: "", Data: null };
        var data = {
            TournamentKey: values.tournamentKey,
            Timestamp: values.timestamp,
        }
        const response = await axios.post(`/api/Tournamented/Delete`, data);
        if (response && response.status === 200) {
            return response.data;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            result.Status = false;
            result.Message = "Unhandled exception";
            return result;
        }
    }
}
export const fetchTournamentedEntryList = async (auth) => {
    let response;
    try {
        if (auth.roleName === "User") {
            response = await axios.post(`/api/Tournamented/Search`, { OwnerKey: auth.key.toString() });
        } else {
            response = await axios.post(`/api/Tournamented/Search`, { createdBy: "" });
        }
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("Fetching Course Error")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
export const fetchTournamentedEntryDetail = async (key) => {
    try {
        const response = await axios.post(`/api/Tournamented/GetByKey`, { Key: key });
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("fetch member detail error.")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
export const fetchTournamentedSponsorIds = async (key) => {
    try {
        const response = await axios.post(`/api/ScoreBoard/GetIdsByKey`, { Key: key });
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("fetch member detail error.")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
export const getSponsorsImages = async (sponsorIds) => {
    try {
        let response = await axios.post(`/api/ScoreBoard/GetSponsorsImages`, { sponsorIds: sponsorIds })
        return response.data;
    } catch (error) {

    }
}
export const GetTournamentByGolfCourseKey = async (id) => {
    try {
        const response = await axios.post(`/api/Tournamented/GetTournamentByGolfCourseKey`, { golfCourseKey: id });
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("Fetching Course Error")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}